import { OnInit, EventEmitter, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Detail, DetailPropertyGroup, DetailProperty, ValueSelection, CombinationProperty, PropertyValidation } from '../objects/DetailObject';
import { DetailService } from '../services/detail.service';
import { KeyValuePipe } from '@angular/common';
import { NgForm, NgModel } from '@angular/forms';
import { DateFormatService } from '../services/date-format.service';
import { AmazingTimePickerService } from 'amazing-time-picker';
import { SummaryService } from '../services/summary.service';
import { ToasterMessageService } from '../services/toaster-message.service';
import { Router } from '@angular/router';
import { ModalControlService } from '../services/modal-control.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MatRadioButton, MatCheckbox } from '@angular/material';
import { Subscription } from 'rxjs';
import { ThemeSettingService } from '../services/theme-setting.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { NgxTimepickerFieldComponent } from 'ngx-material-timepicker';
var PropertyControlsComponent = /** @class */ (function () {
    function PropertyControlsComponent(detailService, dateFormatService, atp, keyValuePipe, toasterMessageService, router, modalControlService, modalService, themeSettingService, cd, workflowReturnService, workspaceService, summaryService, globals) {
        var _this = this;
        this.detailService = detailService;
        this.dateFormatService = dateFormatService;
        this.atp = atp;
        this.keyValuePipe = keyValuePipe;
        this.toasterMessageService = toasterMessageService;
        this.router = router;
        this.modalControlService = modalControlService;
        this.modalService = modalService;
        this.themeSettingService = themeSettingService;
        this.cd = cd;
        this.workflowReturnService = workflowReturnService;
        this.workspaceService = workspaceService;
        this.summaryService = summaryService;
        this.globals = globals;
        this.editorConfig = new Object();
        this.timeValue = "00:00";
        this.defaultTime = "00:00";
        this.retrievingLookupList = false;
        this.showCheckbox = false;
        this.groupCheckbox = [];
        this.originalGroupCheckbox = [];
        this.inputLabel = false;
        this.combinationProperties = [];
        this.showChart = false;
        // tagArray = [];
        this.noValidate = false;
        this.focus = false;
        this.format24h = true;
        this.darkTheme = {
            container: {
                buttonColor: 'var(--primary)'
            },
            dial: {
                dialBackgroundColor: 'var(--primary)',
            },
            clockFace: {
                clockFaceBackgroundColor: 'var(--primary)',
                clockHandColor: '#FFF',
                clockFaceTimeInactiveColor: '#FFF',
                clockFaceTimeActiveColor: 'var(--primary)'
            }
        };
        this.showLoading = new EventEmitter();
        this.reloadDetail = new EventEmitter();
        this.childControl = new EventEmitter();
        this.updateForm = new EventEmitter();
        this.setCurrentLookup = new EventEmitter();
        this.updateHierarchy = new EventEmitter();
        this.showHierarchy = new EventEmitter();
        this.selectedItem = new EventEmitter();
        this.propertyValueChanged = new EventEmitter();
        this.countdownEnd = new EventEmitter();
        this.sub1 = this.detailService.currentPropertyFocusChanged$.subscribe(function (result) {
            if (_this.property.PropertyId == result) {
                if (_this.textbox) {
                    _this.textbox.nativeElement.focus();
                }
                else if (_this.textarea) {
                    _this.textarea.nativeElement.focus();
                }
                else if (_this.select) {
                    _this.select.focus();
                }
                else if (_this.matRadio) {
                    _this.matRadio.focus();
                }
                else if (_this.matCheckbox) {
                    _this.matCheckbox.focus();
                }
            }
            else {
                if (_this.property) {
                    if (_this.property.PropertyFormControlType.toUpperCase() == "COMBINATION") {
                        var combineProperties = [];
                        _this.combinationProperties.map(function (x) { return x.properties; }).forEach(function (element) {
                            combineProperties = combineProperties.concat(element);
                        });
                        var prop = combineProperties.find(function (x) { return x.PropertyId == result; });
                        if (prop) {
                            if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOX" || prop.PropertyFormControlType.toUpperCase() == "DATE") {
                                _this.textbox.nativeElement.focus();
                            }
                            else if (prop.PropertyFormControlType.toUpperCase() == "COMBOBOX" || prop.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX") {
                                _this.select.focus();
                            }
                        }
                    }
                }
            }
        });
        this.sub2 = this.detailService.currentLookupChanged$.subscribe(function (lookup) {
            _this.currentLookup = lookup;
        });
        this.sub3 = this.detailService.parentChildChanged$.subscribe(function (prop) {
            if (prop) {
                if (_this.property.PropertyName == prop.ChildPropertyName) {
                    _this.property.PropertyValue = "";
                    _this.property.PropertyValueDisplay = "";
                    _this.property.isDisabled = true;
                    setTimeout(function () {
                        _this.onValueChange(_this.property, "");
                    });
                }
            }
        });
        this.sub4 = this.detailService.disableChild$.subscribe(function (prop) {
            if (prop) {
                if (_this.property.PropertyName == prop.property.ChildPropertyName) {
                    _this.property.isDisabled = prop.isDisable;
                }
            }
        });
        this.sub5 = this.summaryService.chartTableChanged$.subscribe(function (loading) {
            if (loading) {
                _this.showChart = true;
            }
        });
    }
    Object.defineProperty(PropertyControlsComponent.prototype, "setProperty", {
        set: function (obj) {
            var _this = this;
            var prop = obj.property;
            this.componentId = obj.id;
            if (prop.PropertyFormControlType.toUpperCase() == "DATE") {
                if (prop.PropertyValue) {
                    this.dateValue = new Date(prop.PropertyValue);
                }
                else {
                    this.dateValue = null;
                }
                this.dateFormatService.setFormat(prop.PropertyDisplayFormat.toUpperCase());
                this.handleMinMaxDate(prop);
            }
            else if (prop.PropertyFormControlType.toUpperCase() == "DATETIME") {
                var date = new Date(prop.PropertyValue);
                if (date.getHours()) {
                    var hour = date.getHours().toString();
                    var minute = date.getMinutes().toString();
                    if (date.getHours() < 10) {
                        hour = "0" + date.getHours().toString();
                    }
                    if (date.getMinutes() < 10) {
                        minute = "0" + date.getMinutes().toString();
                    }
                    this.timeValue = hour + ":" + minute;
                    this.defaultTime = this.timeValue;
                }
                this.dateValue = new Date(date);
                this.detailService.getDateTimePropertyDateSegmentValue(this.componentId, prop.PropertyName).subscribe(function (result) {
                    if (prop.PropertyDisplayFormat.indexOf("tt") > -1) {
                        _this.format24h = false;
                        var merd = date.getHours() > 11 ? "pm" : "am";
                        _this.defaultTime = _this.defaultTime + merd;
                    }
                    prop.PropertyDisplayFormat = result;
                    _this.dateFormatService.setFormat(result.toUpperCase());
                    if (prop.PropertyValue) {
                        _this.dateValue = new Date(date);
                    }
                    else {
                        _this.dateValue = null;
                    }
                });
                this.handleMinMaxDate(prop);
            }
            else if (prop.PropertyFormControlType.toUpperCase() == "COMBOBOX") {
                if (!prop.PropertyValueSelection) {
                    prop.PropertyValue = "";
                    prop.PropertyValueDisplay = "";
                }
                else {
                    if (prop.PropertyValueSelection.filter(function (x) { return x.SelectionValue.toLowerCase() == prop.PropertyValue.toLowerCase(); }).length == 0) {
                        prop.PropertyValue = "";
                        prop.PropertyValueDisplay = "";
                    }
                }
                prop.IsDropdownOpen = false;
            }
            else if (prop.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX" || prop.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT" || prop.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT") {
                prop.IsDropdownOpen = false;
                if (prop.PropertyValueSelection) {
                    prop.PropertyValueSelection.forEach(function (element) {
                        element.SelectionMapValue = element.SelectionValue;
                    });
                }
                else {
                    prop.PropertyValueArray = [];
                    prop.PropertyValueDisplayArray = [];
                }
                if (prop.PropertyValueArray) {
                    prop.PropertyValueArray.forEach(function (item, index) {
                        if (prop.PropertyValueSelection.filter(function (x) { return x.SelectionValue.toLowerCase() == item.toLowerCase(); }).length == 0) {
                            prop.PropertyValueArray.splice(index, 1);
                            prop.PropertyValueDisplayArray.splice(index, 1);
                        }
                    });
                }
            }
            else if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOXSUGGEST" || prop.PropertyFormControlType.toUpperCase() == "TEXTBOXSUGGESTID") {
                this.onClickCombobox(prop);
            }
            this.property = prop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyControlsComponent.prototype, "updateProperty", {
        set: function (property) {
            if (property) {
                if (this.property.PropertyId == property.PropertyId) {
                    // var array = [];
                    // property.PropertyValueArray.forEach(element => {
                    //   array.push(element);
                    // });
                    // //this.property.PropertyValueArray = array; // just angular things !
                    var prop = Object.assign({}, property);
                    this.property = prop;
                    this.property.PropertyValueSelection = [].concat(prop.PropertyValueSelection); // remember angular/ng-select use onPush detection strategy
                    this.property.PropertyValueArray = [].concat(prop.PropertyValueArray);
                    var array = property.PropertyValueArray;
                    if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT") {
                        if (property.PropertyValueArray.length > 0) {
                            array = property.PropertyValueArray[0];
                        }
                    }
                    this.updateField(property, array);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyControlsComponent.prototype, "combinationProperty", {
        set: function (combProperty) {
            this.combinationProperties = combProperty;
            if (this.combinationProperties.length > 0) {
                this.combinationProperties.forEach(function (property) {
                    if (property.properties) {
                        if (property.properties.filter(function (x) { return !x.PropertyIsEditable; }).length == 1) {
                            property.IsInputLabel = true;
                        }
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyControlsComponent.prototype, "detailForm", {
        set: function (form) {
            this.ngForm = form;
        },
        enumerable: true,
        configurable: true
    });
    ;
    PropertyControlsComponent.prototype.afterInit = function () {
        this.timepicker.registerOnChange(this.onChangeTime.bind(this));
    };
    PropertyControlsComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    PropertyControlsComponent.prototype.ngOnDestroy = function () {
        if (this.sub1)
            this.sub1.unsubscribe();
        if (this.sub2)
            this.sub2.unsubscribe();
        if (this.sub3)
            this.sub3.unsubscribe();
        if (this.sub4)
            this.sub4.unsubscribe();
        if (this.sub5)
            this.sub5.unsubscribe();
    };
    PropertyControlsComponent.prototype.ngAfterViewInit = function () {
        this.textareaAutoHeight();
        if (this.pdfViewer) {
            this.pdfViewer.refresh();
        }
    };
    PropertyControlsComponent.prototype.textareaAutoHeight = function () {
        var _this = this;
        if (this.textarea) {
            setTimeout(function () {
                var height = _this.textarea.nativeElement.scrollHeight;
                _this.textarea.nativeElement.setAttribute('style', 'height:' + (height) + 'px;');
            });
            this.textarea.nativeElement.addEventListener("input", OnInput, false);
        }
        function OnInput() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight + 5) + 'px';
        }
    };
    PropertyControlsComponent.prototype.handleMinMaxDate = function (prop) {
        if (prop.PropertyValidation) {
            if (prop.PropertyValidation.MinValue == "@CURRENTDATETIME") {
                this.dateMin = new Date();
            }
            else {
                if (prop.PropertyValidation.MinValue) {
                    this.dateMin = new Date(prop.PropertyValidation.MinValue);
                }
            }
            if (prop.PropertyValidation.MaxValue == "@CURRENTDATETIME") {
                this.dateMax = new Date();
            }
            else {
                if (prop.PropertyValidation.MinValue) {
                    this.dateMax = new Date(prop.PropertyValidation.MaxValue);
                }
            }
        }
    };
    PropertyControlsComponent.prototype.onChangeTime = function (time) {
        if (time) {
            if (this.dateValue) {
                var hour = +time.split(':')[0];
                var minute = +time.split(':')[1];
                if (time.indexOf("pm") > -1 || time.indexOf("am") > -1) {
                    time = this.convertTime12to24(time);
                    var hour = +time.split(':')[0];
                    var minute = +time.split(':')[1];
                }
                this.timeValue = hour + ":" + minute;
                this.dateValue.setHours(hour, minute);
                var value = this.dateValue;
                this.handleCustomMinMaxDatetime(this.property, value);
                this.updateField(this.property, value);
            }
        }
    };
    PropertyControlsComponent.prototype.convertTime12to24 = function (time12h) {
        var _a = time12h.split(' '), time = _a[0], modifier = _a[1];
        var _b = time.split(':'), hours = _b[0], minutes = _b[1];
        if (hours == '12') {
            hours = '00';
        }
        if (modifier) {
            if (modifier.toLowerCase() == 'pm') {
                hours = parseInt(hours, 10) + 12;
            }
        }
        return hours + ":" + minutes;
    };
    PropertyControlsComponent.prototype.openTimePicker = function (property) {
        var _this = this;
        var timePicker = this.atp.open({
            time: this.timeValue,
            arrowStyle: {
                background: this.loaderConfig.primaryColour,
                color: '#FFF'
            }
        });
        timePicker.afterClose().subscribe(function (time) {
            _this.onTimeChange(time, property);
        });
    };
    PropertyControlsComponent.prototype.handleCustomMinMaxDatetime = function (property, value, isUpdate) {
        var _this = this;
        if (isUpdate === void 0) { isUpdate = false; }
        if (isNaN(Date.parse(value)) == false) {
            this.handleMinMaxDate(property);
            if (this.dateMin < value) {
                setTimeout(function () {
                    if (_this.ngForm.controls[property.PropertyName].errors) {
                        if (_this.ngForm.controls[property.PropertyName].errors.length == 1) {
                            if (_this.ngForm.controls[property.PropertyName].errors.DateMin) {
                                _this.ngForm.controls[property.PropertyName].setErrors(null);
                            }
                        }
                        else {
                            if (_this.ngForm.controls[property.PropertyName].errors.length > 0) {
                                _this.ngForm.controls[property.PropertyName].setErrors({ 'DateMin': null });
                            }
                        }
                    }
                }, 500); // angular ng on change
            }
            else if (this.dateMin > value) {
                setTimeout(function () {
                    _this.ngForm.controls[property.PropertyName].markAsDirty();
                    _this.ngForm.controls[property.PropertyName].setErrors({ DateMin: true });
                }, 500); // angular ng on change
            }
        }
    };
    PropertyControlsComponent.prototype.onTimeChange = function (time, property) {
        if (time) {
            this.timeValue = time;
            if (this.dateValue) {
                this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
                var value = this.dateValue;
                this.handleCustomMinMaxDatetime(property, value);
                this.updateField(this.property, value);
            }
        }
    };
    PropertyControlsComponent.prototype.onDateTimeChange = function (input, date, ngModel, property) {
        if (ngModel) {
            var isUpdate = false;
            var timestamp = Date.parse(input);
            if (isNaN(timestamp) == false) {
                isUpdate = true;
            }
            else {
                this.dateValue = null;
            }
            if (isUpdate) {
                this.dateValue = new Date(input);
                if (this.dateValue) {
                    this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
                    this.updateField(this.property, this.dateValue);
                }
            }
            this.handleCustomMinMaxDatetime(property, this.dateValue, isUpdate);
        }
        else {
            var timestamp = Date.parse(input);
            if (isNaN(timestamp) == false) {
                this.dateValue = new Date(input);
                if (this.dateValue) {
                    this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
                    this.updateField(this.property, this.dateValue);
                }
            }
            else {
                this.dateValue = null;
            }
        }
    };
    PropertyControlsComponent.prototype.setDateValue = function (value) {
        this.dateValue = new Date(value);
        if (this.dateValue) {
            this.dateValue.setHours(+this.timeValue.split(':')[0], +this.timeValue.split(':')[1]);
        }
    };
    PropertyControlsComponent.prototype.dateChange = function (prop, input, $event) {
        var _this = this;
        var valid = true;
        setTimeout(function () {
            if ($event) {
                valid = $event.valid;
            }
            if (valid) {
                var timestamp = Date.parse(input);
                if (isNaN(timestamp) == false) {
                    _this.dateValue = new Date(input);
                    _this.dateValue.setHours(+_this.timeValue.split(':')[0], +_this.timeValue.split(':')[1]);
                    _this.updateField(prop, _this.dateValue);
                    _this.handleCustomMinMaxDatetime(prop, _this.dateValue);
                }
                else {
                    if (!_this.property.PropertyValidation)
                        _this.property.PropertyValidation = new PropertyValidation();
                    if (!input) {
                        _this.dateValue = null;
                        _this.updateField(prop, _this.dateValue);
                        _this.property.PropertyValidation.InvalidFormat = false;
                    }
                    else {
                        _this.property.PropertyValidation.InvalidFormat = true;
                    }
                }
                _this.updateField(prop, _this.dateValue);
            }
            else {
                // ng model has error
                if ($event.errors.matDatepickerMin || $event.errors.matDatepickerMax) {
                    //min max date error
                    _this.property.PropertyValidation.InvalidFormat = false;
                    _this.dateValue = new Date(input);
                }
            }
        });
    };
    PropertyControlsComponent.prototype.onTextboxSuggest = function (property, event) {
        if (event) {
            this.onValueChange(property, event.item.SelectionValue);
        }
    };
    PropertyControlsComponent.prototype.onValueChange = function (property, value, $event) {
        var _this = this;
        if ($event === void 0) { $event = null; }
        if (property.PropertyFormControlType.toUpperCase() == "COMBOBOX") {
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).IsDropdownOpen = false;
        }
        var valid = true;
        if ($event) {
            setTimeout(function () {
                valid = $event.valid;
                if ($event.errors) {
                    if ($event.errors.required && value) {
                        valid = true;
                    }
                }
                else {
                    if (property.PropertyValidation) {
                        if (property.PropertyValidation.MinMaxType == "NUMBER") {
                            if (property.PropertyValidation.MinValue) {
                                var minValue = property.PropertyValidation.MinValue;
                                if (minValue == "@CURRENTYEAR")
                                    minValue = new Date().getFullYear().toString();
                                if (parseInt(value) < parseInt(minValue)) {
                                    setTimeout(function () { return _this.ngForm.controls[property.PropertyName].setErrors({ pattern: true }); });
                                }
                            }
                            if (property.PropertyValidation.MaxValue) {
                                var maxValue = property.PropertyValidation.MaxValue;
                                if (maxValue == "@CURRENTYEAR")
                                    maxValue = new Date().getFullYear().toString();
                                if (parseInt(value) > parseInt(maxValue)) {
                                    setTimeout(function () { return _this.ngForm.controls[property.PropertyName].setErrors({ pattern: true }); });
                                }
                            }
                        }
                    }
                }
                _this.handleValuePassed(property, value, valid);
            });
        }
        else {
            this.handleValuePassed(property, value, valid);
        }
    };
    PropertyControlsComponent.prototype.handleValuePassed = function (property, value, valid) {
        var newValue;
        var selectionValue;
        if (property.PropertyFormControlType.toUpperCase() == "TEXTBOX" && property.PropertyDisplayFormat.toUpperCase() == "UPPER") {
            value = value.toUpperCase();
        }
        if (property.PropertyFormControlType.toUpperCase() == "CHECKBOX") {
            this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.source.value; }).IsSelected = value.checked;
            selectionValue = this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.source.value; }).SelectionValue;
            var result = this.property.PropertyValueSelection.filter(function (x) { return x.IsSelected; }).map(function (a) { return a.SelectionValue; });
            this.property.PropertyValueArray = result;
            newValue = result;
        }
        else if (property.PropertyFormControlType.toUpperCase() == "COMBOBOX") {
            if (property.ChildPropertyName) {
                this.detailService.clearChild(property);
                this.detailService.setDisableChild({ property: property, isDisable: true });
            }
            if (property.PropertyValidation && value) {
                valid = true;
            }
            newValue = value;
        }
        else if (property.PropertyFormControlType.toUpperCase() == "MULTITEXT") {
            newValue = [];
            value.forEach(function (element) {
                if (element.label) {
                    newValue.push(element.label);
                }
                else {
                    newValue.push(element);
                }
            });
        }
        else if (property.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX") {
            newValue = [];
            value.forEach(function (x) {
                if (x.GroupBy && !x.SelectionMapValue) {
                    var list = property.PropertyValueSelection.filter(function (g) { return g.GroupBy == x.GroupBy; });
                    list.forEach(function (element) {
                        newValue.push(element.SelectionMapValue);
                    });
                }
                else {
                    newValue.push(x.SelectionMapValue);
                }
            });
        }
        else if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT") {
            if (property.PropertyValueArray.length > 0) {
                newValue = property.PropertyValueArray[0];
                property.PropertyValueSelection.forEach(function (element) {
                    if (newValue) {
                        if (element.SelectionValue.toLowerCase() == newValue.toLowerCase()) {
                            element.IsSelected = !element.IsSelected;
                        }
                        else {
                            element.IsSelected = false;
                        }
                    }
                    else {
                        element.IsSelected = false;
                    }
                });
            }
            else {
                property.PropertyValueSelection.forEach(function (x) {
                    x.IsSelected = false;
                });
            }
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueArray = property.PropertyValueArray;
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = property.PropertyValueSelection;
            var newProp = Object.assign({}, this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }));
            this.updateHierarchy.emit(newProp);
        }
        else if (property.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT") {
            newValue = [];
            value.forEach(function (x) {
                newValue.push(x.SelectionValue);
            });
            var array = [];
            property.PropertyValueSelection.forEach(function (element) {
                if (newValue.indexOf(element.SelectionValue) > -1) {
                    element.IsSelected = true;
                }
                else {
                    element.IsSelected = false;
                }
                array.push(element);
            });
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueArray = newValue;
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = array;
            // let copy = JSON.parse(JSON.stringify(this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId))); // just angular things !
            var newProp = Object.assign({}, this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }));
            this.updateHierarchy.emit(newProp);
        }
        else if (property.PropertyFormControlType.toUpperCase() == "DATE") {
            var timestamp = Date.parse(value);
            if (isNaN(timestamp) == false) {
                valid = true;
                this.dateValue = new Date(value);
                newValue = this.dateValue;
            }
            else {
                if (value) {
                    valid = false;
                    newValue = value;
                    if (!this.property.PropertyValidation)
                        this.property.PropertyValidation = new PropertyValidation();
                    if (!value) {
                        this.property.PropertyValidation.InvalidFormat = false;
                    }
                    else {
                        this.property.PropertyValidation.InvalidFormat = true;
                    }
                }
                else {
                    // empty string
                    valid = true;
                    newValue = value;
                }
            }
        }
        else {
            newValue = value;
        }
        if (valid) {
            this.updateField(property, newValue, selectionValue);
        }
    };
    PropertyControlsComponent.prototype.search = function (property, $event) {
        if (this.currentLookup != property.PropertyName) {
            this.onClickCombobox(property, property.PropertyFormControlType.toUpperCase() == 'COMBOBOX' ? true : false);
        }
        else {
            this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).IsDropdownOpen = true;
            if ($event.keyCode == 13 && property.PropertyFormControlType.toUpperCase() == 'COMBOBOX') {
                this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).IsDropdownOpen = false;
            }
        }
    };
    PropertyControlsComponent.prototype.updateField = function (prop, value, selectionValue) {
        var _this = this;
        if (selectionValue === void 0) { selectionValue = ""; }
        var property = this.property;
        var selection;
        selection = selectionValue;
        if (prop) {
            property = prop;
        }
        if (property.TriggersWorkflow) {
            this.showLoading.emit(true);
        }
        if (prop.PropertyFormControlType.toUpperCase() == "TEXTBOX" || prop.PropertyFormControlType.toUpperCase() == "PASSWORD" || prop.PropertyFormControlType.toUpperCase() == "SECURETEXTBOX") {
            if (this.ngForm) {
                if (prop.ParentPropertyName) {
                    if (this.ngForm.control.get(prop.ParentPropertyName)) {
                        if (value != this.ngForm.control.get(prop.ParentPropertyName).value) {
                            // wait one tick, otherwise angular change will override
                            setTimeout(function () { return _this.ngForm.controls[prop.PropertyName].setErrors({ noMatch: true }); });
                        }
                        else {
                            setTimeout(function () { return _this.ngForm.controls[prop.ParentPropertyName].setErrors(null); });
                        }
                    }
                }
                else if (prop.ChildPropertyName) {
                    if (this.ngForm.control.get(prop.ChildPropertyName)) {
                        if (value != this.ngForm.control.get(prop.ChildPropertyName).value) {
                            // wait one tick, otherwise angular change will override
                            setTimeout(function () { return _this.ngForm.controls[prop.PropertyName].setErrors({ noMatch: true }); });
                        }
                        else {
                            setTimeout(function () { return _this.ngForm.controls[prop.ChildPropertyName].setErrors(null); });
                        }
                    }
                }
            }
        }
        var timestamp = Date.parse(value);
        if (isNaN(timestamp) == false) {
            setTimeout(function () {
                _this.dateValue = new Date(value);
            });
        }
        if (this.property.PropertyFormControlType.toUpperCase() == "COMBOBOX") {
            if (this.property.PropertyValueSelection) {
                if (this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue.toLowerCase() == value.toLowerCase(); })) {
                    this.property.PropertyValueDisplay = this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue.toLowerCase() == value.toLowerCase(); }).SelectionDisplay;
                }
            }
        }
        this.detailService.pushPendingUpdate(property, value);
        this.detailService.updateField(this.componentId, property.PropertyName, value, selection).subscribe(function (result) {
            _this.detailService.removePendingUpdate(property.PropertyId);
            if (property.ChildPropertyName) {
                _this.detailService.setDisableChild({ property: property, isDisable: false });
            }
            if (result) {
                if (result.startsWith("#WF:")) {
                    _this.handleWorkflowReturn(result.substr(4), property);
                }
                else {
                    if (property.PropertyFormControlType.toUpperCase() != "TEXTBOXSUGGESTID") {
                        property.PropertyValueDisplay = result;
                        if (property.PropertyFormControlType.toUpperCase() == "DATE" || property.PropertyFormControlType.toUpperCase() == "DATETIME") {
                            _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).PropertyValue = result;
                        }
                    }
                }
            }
        });
    };
    PropertyControlsComponent.prototype.handleWorkflowReturn = function (result, property) {
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:// navigate
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1://message
                this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                break;
            case 3:
                this.propertyValueChanged.emit(command.Arguments[0]);
                if (property.TriggersWorkflow) {
                    this.showLoading.emit(false);
                }
                break;
            case 4:
                this.propertyValueChanged.emit(command.Arguments[0]);
                if (property.TriggersWorkflow) {
                    this.showLoading.emit(false);
                }
                break;
            case 5:
                this.propertyValueChanged.emit(command.Arguments[0]);
                if (property.TriggersWorkflow) {
                    this.showLoading.emit(false);
                }
            case 6: // comparison
            case 7: // download file
            case 8: // messagenavigate
            case 9: // chart
            case 10: // go home and navigate
            case 11: // open form
            case 12:// external navigate
                this.workflowReturnService.handleWorkflowReturn(command);
                break;
        }
        if (command.RefreshType) {
            switch (command.RefreshType) {
                case "self":
                    this.reloadDetail.emit(result);
                    break;
                case "parent":
                    this.reloadDetail.emit(result);
                    this.getEPICParent(false, command.ReturnType, command.IsPreview);
                    break;
                case "all":
                    this.reloadDetail.emit(result);
                    this.getEPICParent(true, command.ReturnType, command.IsPreview);
                    break;
            }
        }
        else {
            this.showLoading.emit(false);
        }
    };
    PropertyControlsComponent.prototype.getEPICParent = function (findAllParent, returnType, isPreview) {
        var _this = this;
        if (isPreview === void 0) { isPreview = false; }
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
            });
        }
    };
    PropertyControlsComponent.prototype.getCombinationProperty = function (propertyId) {
        if (this.combinationProperties.filter(function (x) { return x.IsInputLabel; }).length > 0) {
            this.inputLabel = true;
        }
        else {
            this.inputLabel = false;
        }
        return this.combinationProperties.find(function (x) { return x.combinationId == propertyId; }).properties;
    };
    PropertyControlsComponent.prototype.checkProp = function (prop) {
        console.log(prop);
    };
    PropertyControlsComponent.prototype.checkIfCombinationIsEditable = function (propertyId, prop) {
        // if (this.combinationProperties.find(x => x.combinationId == propertyId).properties.filter(x => x.PropertyIsEditable).length > 0){
        //   return true;
        // }
        // else{
        //   return false;
        // }
        if (!prop)
            return false;
        var propExist = this.combinationProperties.find(function (x) { return x.combinationId == propertyId; }).properties.find(function (x) { return x.PropertyId == prop.PropertyId; });
        if (propExist) {
            if (propExist.PropertyIsEditable && propExist.PropertyFormControlType.toUpperCase() == "LABEL") {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    PropertyControlsComponent.prototype.getPropertyWidth = function (propertyId, order) {
        if (order == 0) {
            return this.combinationProperties.find(function (x) { return x.combinationId == propertyId; }).columnWidth[0].initialColumnWidth;
        }
        else {
            return this.combinationProperties.find(function (x) { return x.combinationId == propertyId; }).columnWidth[0].secColumnWidth;
        }
    };
    PropertyControlsComponent.prototype.onClickCombobox = function (property, isSingle, $event) {
        var _this = this;
        if (isSingle === void 0) { isSingle = false; }
        if ($event === void 0) { $event = null; }
        if (!property.isDisabled) {
            if (this.isPopupDetail) {
                document.querySelectorAll("body").item(0).style.position = "relative";
            }
            if ($event) {
                if (!$event.target.classList.contains("ng-value-icon")) {
                    this.showCheckbox = !this.showCheckbox;
                }
            }
            if (this.currentLookup != property.PropertyName) {
                this.detailService.setLookup(property.PropertyName);
                this.retrievingLookupList = true;
                this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(function (result) {
                    var lookupList = JSON.parse(result);
                    _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).PropertyValueSelection = lookupList;
                    _this.property.PropertyValueSelection = lookupList;
                    _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).IsDropdownOpen = true;
                    // this.detailObject.Properties[this.detailObject.Properties.findIndex(x => x.PropertyName == property)]
                    _this.retrievingLookupList = false;
                    _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).PropertyValueSelection.forEach(function (element) {
                        element.SelectionMapValue = element.SelectionValue;
                    });
                    if (_this.property.PropertyFormControlType.toUpperCase() == "GROUPCHECKBOX") {
                        var grouped = _this.groupBy(_this.property.PropertyValueSelection, function (PropertyValueSelection) { return PropertyValueSelection.GroupBy; });
                        _this.groupCheckbox = _this.keyValuePipe.transform(grouped);
                        _this.originalGroupCheckbox = _this.groupCheckbox;
                        if (!_this.groupCheckbox)
                            _this.groupCheckbox = [];
                        if (_this.property.PropertyValueArray) {
                            _this.property.PropertyValueArray.forEach(function (value) {
                                var valueSelection = _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).PropertyValueSelection.find(function (x) { return x.SelectionValue == value; });
                                if (valueSelection) {
                                    valueSelection.IsSelected = true;
                                }
                            });
                        }
                    }
                }, function (error) {
                    _this.retrievingLookupList = false;
                });
            }
            else {
                if (isSingle) {
                    this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).IsDropdownOpen = !this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).IsDropdownOpen;
                }
                else {
                    this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).IsDropdownOpen = true;
                }
            }
        }
    };
    PropertyControlsComponent.prototype.onSearch = function (event) {
        this.showCheckbox = true;
        var matchByParent = this.originalGroupCheckbox.filter(function (x) { return x.key["name"].toLowerCase().includes(event.term.toLowerCase()); });
        if (event.items.length > 0) {
            var grouped = this.groupBy(event.items, function (PropertyValueSelection) { return PropertyValueSelection.GroupBy; });
            var tempCheckbox = this.keyValuePipe.transform(grouped);
            matchByParent.forEach(function (element) {
                if (tempCheckbox.filter(function (x) { return x.key["name"].toLowerCase().includes(element.key["name"].toLowerCase()); }).length == 0) {
                    tempCheckbox.push(element);
                }
            });
            this.groupCheckbox = this.sortGroupCheckbox(tempCheckbox);
        }
        else {
            this.groupCheckbox = matchByParent;
        }
    };
    PropertyControlsComponent.prototype.sortGroupCheckbox = function (data) {
        return data.sort(function (a, b) {
            if (a.key["name"] > b.key["name"]) {
                return 1;
            }
            else if (a.key["name"] < b.key["name"]) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    PropertyControlsComponent.prototype.onBlur = function (property) {
        this.focus = false;
        this.detailObject.Properties.find(function (x) { return x.PropertyName == property.PropertyName; }).IsDropdownOpen = false;
        // document.querySelectorAll(".overlay-container").item(0).classList.remove("block");
    };
    PropertyControlsComponent.prototype.onCloseCombobox = function () {
        if (this.isPopupDetail) {
            document.querySelectorAll("body").item(0).style.position = "initial";
        }
        // document.querySelectorAll(".overlay-container").item(0).classList.remove("block");
    };
    PropertyControlsComponent.prototype.getNestedChildren = function (arr, parent) {
        var out = [];
        for (var i in arr) {
            if (arr[i].parent == parent) {
                var children = this.getNestedChildren(arr, arr[i].id);
                if (children.length) {
                    arr[i].children = children;
                }
                out.push(arr[i]);
            }
        }
        return out;
    };
    PropertyControlsComponent.prototype.toggleHierarchy = function (property) {
        this.showHierarchy.emit(!this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyShowHierarchy);
        // this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyShowHierarchy = !this.detailObject.Properties.find(x => x.PropertyId == property.PropertyId).PropertyShowHierarchy;
    };
    PropertyControlsComponent.prototype.onGroupCheckboxChange = function ($event, ngModel) {
        var _this = this;
        if (ngModel === void 0) { ngModel = null; }
        var array = [];
        var groupBy = [];
        if ($event.length == 0) {
            if (this.groupCheckbox.length > 0) {
                this.groupCheckbox.forEach(function (element) {
                    element['key'].isSelected = false;
                });
            }
        }
        $event.forEach(function (element) {
            array.push(element.SelectionValue);
        });
        this.property.PropertyValueArray = array;
        this.property.PropertyValueSelection.forEach(function (value) {
            value.IsSelected = false;
        });
        this.property.PropertyValueArray.forEach(function (value) {
            if (_this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value; })) {
                _this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value; }).IsSelected = true;
                groupBy.push(_this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value; }).GroupBy);
            }
        });
        // probably do this later, check whether theres no child anymore
        // console.log(this.property.PropertyValueSelection);
        // groupBy.forEach(groupId => {
        //   console.log(this.property.PropertyValueSelection.filter(x => x.GroupBy == groupId).filter(x => x.IsSelected));
        //   if (this.property.PropertyValueSelection.filter(x => x.GroupBy == groupId).filter(x => x.IsSelected).length == 0){
        //     console.log(this.groupCheckbox.filter(x => x["key"].name == groupId));
        //   }
        // });
        this.onValueChange(this.property, this.property.PropertyValueArray, ngModel);
    };
    PropertyControlsComponent.prototype.closeCheckbox = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.showCheckbox = false;
    };
    PropertyControlsComponent.prototype.clearAll = function () {
        this.property.PropertyValueArray = [];
        this.property.PropertyValueSelection.forEach(function (value) {
            value.IsSelected = false;
        });
        this.groupCheckbox.forEach(function (element) {
            element['key'].isSelected = false;
        });
    };
    PropertyControlsComponent.prototype.onSelectedItem = function (id) {
        this.selectedItem.emit(id);
    };
    PropertyControlsComponent.prototype.addToPropArray = function ($event, selection, isParent, key) {
        var _this = this;
        if (isParent) {
            selection.forEach(function (value) {
                _this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.SelectionValue; }).IsSelected = !_this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.SelectionValue; }).IsSelected;
                _this.pushPropertyValue($event, value);
            });
        }
        else {
            this.pushPropertyValue($event, selection);
        }
        this.onValueChange(this.property, this.property.PropertyValueArray);
    };
    PropertyControlsComponent.prototype.groupBy = function (list, keyGetter) {
        var map = new Map(); // create into map
        var someList = [];
        list.forEach(function (item) {
            var key = keyGetter(item);
            var obj = { name: key, isSelected: false };
            if (someList.indexOf(key) >= 0) {
                map.forEach(function (result) {
                    if (result[0].GroupBy == key) {
                        result.push(item);
                    }
                });
            }
            else {
                map.set(obj, [item]);
            }
            someList.push(key);
        });
        return map;
    };
    PropertyControlsComponent.prototype.compareFn = function (item, selected) {
        return item.SelectionValue.toLowerCase() == selected.toLowerCase();
    };
    // groupBy(list, keyGetter) {
    //   const map = new Map(); // create into map
    //   list.forEach((item) => {
    //       const key = keyGetter(item);
    //       if (!map.has(key)) {
    //         map.set(key, [item]);
    //       } else {
    //         map.get(key).push(item);
    //       }
    //   });
    //   return map;
    // }
    PropertyControlsComponent.prototype.pushPropertyValue = function ($event, value) {
        if ($event.currentTarget.checked) {
            if (this.property.PropertyValueArray) {
                if (this.property.PropertyValueArray.indexOf(value.SelectionValue) < 0) {
                    this.property.PropertyValueArray.push(value.SelectionValue);
                    this.property.PropertyValueArray = this.property.PropertyValueArray.filter(function (x) { return x !== "@*novalue*@"; });
                }
            }
            else {
                this.property.PropertyValueArray = [];
                this.property.PropertyValueArray.push(value.SelectionValue);
            }
            this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.SelectionValue; }).IsSelected = true;
        }
        else {
            this.property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value.SelectionValue; }).IsSelected = false;
            this.property.PropertyValueArray = this.property.PropertyValueArray.filter(function (x) { return x !== value.SelectionValue; });
        }
    };
    PropertyControlsComponent.prototype.setCountdownEvent = function (event) {
        this.countdownEnd.emit(event);
    };
    PropertyControlsComponent.prototype.optionalChanged = function (event) {
        var _this = this;
        var checked = event;
        this.noValidate = checked;
        var properties = this.detailObject.Properties.filter(function (x) { return x.ParentPropertyName == _this.property.PropertyName; });
        properties.forEach(function (prop) {
            prop.PropertyClientIsHidden = !checked;
        });
    };
    PropertyControlsComponent.prototype.setAttachmentValue = function (value) {
        this.property.PropertyValue = value;
        this.updateField(this.property, value);
    };
    PropertyControlsComponent.prototype.onPaste = function (property, e) {
        e.stopPropagation();
        e.preventDefault();
        var items = e.clipboardData.getData('Text').split(/\r?\n/).map(function (item) { return item.trim(); });
        property.PropertyValueDisplayArray = items;
        if (items) {
            this.updateField(property, items);
        }
    };
    return PropertyControlsComponent;
}());
export { PropertyControlsComponent };
